import type { AxiosRequestConfig } from 'axios';
import { srmInstance } from '@/shared/api/api-instances/srm/api-instance';
import type { CreateWidget, UpdateWidget, Widget } from '../model/widget';

export class WidgetApi {
  // getWidgetList(options: AxiosRequestConfig = {}) {
  //   return srmInstance.get<WidgetListResponse[]>('/widgets', options);
  // }

  static updateWidget(widget: UpdateWidget, options: AxiosRequestConfig = {}) {
    return srmInstance.put<Widget>(`/tab/widget`, widget, options);
  }

  static deleteWidget(
    id: string,
    tab_id: string,
    options: AxiosRequestConfig = {},
  ) {
    return srmInstance.delete(`/tab/${tab_id}/widget/${id}`, options);
  }

  static createWidget(payload: CreateWidget, options: AxiosRequestConfig = {}) {
    return srmInstance.post<Record<string, Widget['config']>>(
      '/tab/widget',
      payload,
      options,
    );
  }
}